import type { RuleHandler } from "../types";

const checkMinimumSelectionOdds: RuleHandler = (context, requirement) => {
  const minOdds = requirement.userDrivenAttributes?.minimumSelectionOdds!;

  // check that every outcome (selection) has odds higher than mininum selection odds
  return context.selection.outcomes.every((outcome) => outcome.odds >= minOdds);
};

export { checkMinimumSelectionOdds };
